import http from "./http-common";
import qs from "qs";
import ActivitiesModel from "../models/activities";
import { startOfDay, endOfDay } from "../functions/dateRange";

// Navbar APIs
// eslint-disable-next-line
export default new (class ActivitiesService {
  // Get all members
  async getActivities({
    keyword,
    startDate,
    endDate,
    sort = "desc",
    page = 1,
    pageSize = 5,
  }) {
    // sort = "order" → ตามลำดับที่แอดมินจัด (วันที่ล่าสุดก่อนเมื่อ order เท่ากัน)
    //        "asc"/"desc" → ตามวันที่จัดกิจกรรม
    const sortBy =
      sort === "order" ? ["order:asc", "event.startDate:desc"] : [`event.startDate:${sort}`];

    // ค้นหาคำใน ชื่อ/รายละเอียด ทั้งสองภาษา
    const keywordFilter = {
      $or: [
        { activity: { event_TH: { $contains: keyword } } },
        { activity: { event_EN: { $contains: keyword } } },
        { detail: { detail_TH: { $contains: keyword } } },
        { detail: { detail_EN: { $contains: keyword } } },
      ],
    };

    // ช่วงเวลา: เอากิจกรรมที่ "คาบเกี่ยว" กับช่วงที่เลือก
    // เริ่มก่อนหรือในวันสุดท้าย และ (จบหลังหรือในวันแรก หรือไม่ได้ใส่วันจบแต่เริ่มในช่วง)
    const dateFilter =
      startDate && endDate
        ? {
            event: {
              startDate: { $lte: endOfDay(endDate) },
            },
            $or: [
              { event: { endDate: { $gte: startOfDay(startDate) } } },
              {
                event: {
                  endDate: { $null: true },
                  startDate: { $gte: startOfDay(startDate) },
                },
              },
            ],
          }
        : null;

    const query = qs.stringify(
      {
        sort: sortBy,
        filters: {
          $and: [keywordFilter, ...(dateFilter ? [dateFilter] : [])],
        },
        pLevel: 5,
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/activities?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((activity) => ActivitiesModel.get(activity))
        );

        const meta = response.data.meta;

        return [data, meta];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getMainpageActivities() {
    return await http
      .get(
        "/activities?sort[0]=order:asc&sort[1]=event.startDate:asc&filters[isActive][$eq]=true&pLevel&pagination[pageSize]=3"
      )
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((activity) => ActivitiesModel.get(activity))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get by name
  async getActivitiesBySlug(slug, status = 'published') {
    return await http
      // ให้ Strapi กรองด้วย slug — ดึงมาทั้งหมดแล้วค่อยหาจะได้แค่ 25 รายการแรก
      .get(`/activities?pLevel&status=${status}&filters[Slug][$eq]=${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((activity) => ActivitiesModel.get(activity))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getActivitiesByTag({ sort = "desc", tag = "" }) {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              tag: {
                tag: {
                  $eq: tag,
                },
              },
            },
          ],
        },
        // sort: [`event[startDate]:${sort}`],
        pLevel: 5,
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/activities?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((activites) => ActivitiesModel.get(activites))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
